import React, {useEffect, useState} from 'react';
import { useFetch } from "../../../../components/common/FetchProvider";
import CommonTable from "./CommonTable";
import AddCategoryModal from "../components/AddCategoryModal"
import CategoryModal from "../components/CategoryModal"
import { columnsDataCategory } from "../variables/columnsData";

function ColumnsTable() {
  const fetchWrapper = useFetch();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [error, setError] = useState(false);
  const [categoryData, setCategoryData] = useState(null);

  const [showFirstModal, setShowFirstModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const handleLinkClick = (e) => {
    setShowFirstModal(false); // Close the first modal
    setShowSecondModal(true); // Open the second modal
  };

  const refreshData = () => {
    reload();
  }

  const reload = () => {
    setApiData([]);
    setCategoryData(null);
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/employee-category`;

      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data && responseData.data.length > 0) {
          setApiData(responseData.data);
        } else {
          setError(true);
        }
      } else {
        setError(true);
        console.error('Error fetching API data:', response.status);
      }
    } catch (error) {
      setLoading(false);
      setError(true);
      console.error('Error fetching API data:', error);
    }
  };

  const mappedApiData = apiData.map((item) => ({
    id: item.id,
    name: item.name,
    action: "Action"
  }));

  const handleActionClick = (rowData) => {
    let data = apiData.find((item) => item.id === rowData.id);
    setCategoryData(data);
    handleLinkClick();
  };

  return (
      <div className="10">
        <header className="relative flex items-center justify-between">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
          </div>
          {/* Links with Separator */}
          <div className="flex justify-center items-center font-bold text-brand-600">
            <div>
              <button onClick={handleLinkClick}>Cadastrar</button>
              {/* Conditional rendering of modal */}
              {showFirstModal && (
                  <CategoryModal
                      showModal={showFirstModal}
                      setModalState={setShowFirstModal}
                      handleLinkClick={handleLinkClick} // Pass handleLinkClick to first modal
                  />
              )}

              {/* Conditional rendering of the second modal */}
              {showSecondModal && (
                  <AddCategoryModal
                      showModal={showSecondModal}
                      setModalState={setShowSecondModal}
                      refreshData={refreshData}
                      categoryData={categoryData}
                      setCategoryData={setCategoryData}
                  />
              )}
            </div>

          </div>

        </header>

        <div className="mt-1">
          {loading ? (
              <div></div>
          ) : apiData && apiData.length > 0 ? (
              <CommonTable
                  columnsData={columnsDataCategory}
                  tableData={mappedApiData}
                  onActionClick={handleActionClick}
              />
          ) : (
              <></>
          )}
        </div>
      </div>
  );
}

export default ColumnsTable;
